var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLikeOn = function SvgIconLikeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.615 1.126a3.782 3.782 0 0 1 5.385 0 3.782 3.782 0 0 1 5.385 0 3.871 3.871 0 0 1 0 5.437l-4.967 5.015a.589.589 0 0 1-.836 0L1.615 6.563a3.87 3.87 0 0 1 0-5.437Z",
    fill: "#FF3A58"
  })));
};
export default SvgIconLikeOn;